module.exports = __webpack_public_path__ + "img/info5ss.27e64bdf.jpg";